import { Typography } from '@mui/material'
import CellHOC from '@platform/react/hoc/list/cell'

/**
 * Displays a cell with the status of an TypeExtension.
 *
 * @param {Object} classes  styling for the cell
 * @param {Object} props    props for the cell
 *
 * @returns {React.ReactNode}
 */
export const ListItemCellTypeExtensionStatus = (classes, props = {}) => {
  const { status } = props

  return (
    <Typography
      color={'black'}
      variant={'14/regular'}
      className={classes.row}
      sx={{ fontWeight: 700 }}
    >
      {status}
    </Typography>
  )
}

export default CellHOC(ListItemCellTypeExtensionStatus)
